module.exports = __webpack_public_path__ + "img/10_TAMARIN.b82eee6e.jpg";